<template>
  <b-card no-body v-draggable class="popup app-ctrl" style="max-width: unset!important">
    <b-card-header  style="color: lightgrey; height: 25px; cursor: move; "
                    class="pl-2 pb-0 pt-0"
                    header-tag="div"
                    header-bg-variant="dark">
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          {{ surveyWave.KpiGroupName }} - {{ Kpi.Name }}
        </b-col>
        <b-col class="mx-0 px-0" cols="1" style="text-align: right">
          <font-awesome-icon class="mx-1 clickable" :icon="['far', 'times']" @click="$emit('close')" />
        </b-col>
      </b-row>
    </b-card-header>
    <div style="background-color: rgba(211, 211, 211, 0.333); margin: auto;" v-if="isLoading" v-bind:class="{ spinner: isLoading }"></div>
    <b-card-text v-else class="content">
      <div>
        <h5 v-if="kpiQuestions_SophusMonthly && Kpi.SophusMonthly"> Quarter Results</h5>
        <div v-if="isEmpty_kpiQuestions">No Results to show.</div>
        <div v-for="(survey, surveyId) in kpiQuestions" :key="surveyId">
          <div style="display:flex; align-items:center">
            <h5>
              {{survey[0].SurveyTitle}}: {{survey[0].ExternalSurveyInstanceId}} - {{ $t('Webportal.CX.Margin.CheckDate') }}: {{ new Date(survey[0].TimeStampSurveyEnd).toLocaleDateString("de-DE")}}
            </h5>
            <b-button 
                class="m-1 p-0" 
                variant="outline-primary" 
                size="sm" 
                style="border:none" 
                v-b-tooltip.hover.nofade="toolTipDelay" 
                :title="$t('Webportal.CX.Margin.DownloadCheckReportTooltip')"
                @click="downloadCheckReport(survey[0].SurveyInstanceId)"
                :disabled="isExporting">
              <i class="fal fa-file-pdf m-1" style="font-size:16pt"></i>
            </b-button>
          </div>
          <table class="table table-bordered">
            <thead>
              <th class="align-middle" >{{ $t('Webportal.CX.Margin.Question') }}</th>
              <th class="align-middle" style="width:25%" >{{ $t('Webportal.CX.Margin.Answer') }}</th>
              <th v-if="hasUploadQuestion && userHasMediaExplorerPermission" class="align-middle" style="width:10%">{{ $t('Webportal.CX.Margin.ShowUpload') }}</th>
            </thead>
            <tbody class="table-body">
              <tr v-for="question in survey" :key="question.QuestionText" :class="{ 'table-success': question.IsPositiveAnswer, 'table-danger': !question.IsPositiveAnswer }">
                <td>{{ question.QuestionText }}</td>
                <td>
                  <font-awesome-icon :icon="['far', 'times']" v-if="!question.IsPositiveAnswer"></font-awesome-icon>
                  <font-awesome-icon :icon="['far', 'check']" v-if="question.IsPositiveAnswer"></font-awesome-icon>
                  {{ question.SurveyAnswerText}}
                </td>
                <td v-if="hasUploadQuestion && userHasMediaExplorerPermission">
                  <!-- disable if question.UploadQuestion.SurveyInstanceId & SurveyQuestionId are null or undefined -->
                  <button class="btn btn-light" v-if="question.UploadQuestion && question.UploadQuestion.hasUploadFile" @click="toggleUpload(question.UploadQuestion)">
                    <font-awesome-icon 
                      :icon="['far', 'eye-slash']" 
                      v-if="uploadToggled && shownUploadQuestionId == question.UploadQuestion.SurveyQuestionId && shownUploadSurveyInstanceId == question.UploadQuestion.SurveyInstanceId"
                    ></font-awesome-icon>
                    <font-awesome-icon :icon="['far', 'eye']" v-else ></font-awesome-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>  
        <!-- sophus monthly special treatment -->
        <template v-if="kpiQuestions_SophusMonthly && Kpi.SophusMonthly">
          <h5 class="mt-2">Monthly Results</h5>
          <div v-for="(survey, surveyId) in kpiQuestions_SophusMonthly" :key="surveyId">
            <div style="display:flex; align-items:center">
              <h5>
                {{survey[0].SurveyTitle}}: {{survey[0].ExternalSurveyInstanceId}} - {{ $t('Webportal.CX.Margin.CheckDate') }}: {{ new Date(survey[0].TimeStampSurveyEnd).toLocaleDateString("de-DE")}}
              </h5>
              <b-button 
                  class="m-1 p-0" 
                  variant="outline-primary" 
                  size="sm" 
                  style="border:none" 
                  v-b-tooltip.hover.nofade="toolTipDelay" 
                  :title="$t('Webportal.CX.Margin.DownloadCheckReportTooltip')"
                  @click="downloadCheckReport(survey[0].SurveyInstanceId)"
                  :disabled="isExporting">
                <i class="fal fa-file-pdf m-1" style="font-size:16pt"></i>
              </b-button>
            </div>
            <table class="table table-bordered">
              <thead>
                <th class="align-middle" >{{ $t('Webportal.CX.Margin.Question') }}</th>
                <th class="align-middle" style="width:25%" >{{ $t('Webportal.CX.Margin.Answer') }}</th>
                <th v-if="hasUploadQuestion && userHasMediaExplorerPermission" class="align-middle" style="width:10%">{{ $t('Webportal.CX.Margin.ShowUpload') }}</th>
              </thead>
              <tbody class="table-body">
                <tr v-for="question in survey" :key="question.QuestionText" :class="{ 'table-success': question.IsPositiveAnswer, 'table-danger': !question.IsPositiveAnswer }">
                  <td>{{ question.QuestionText }}</td>
                  <td>
                    <font-awesome-icon :icon="['far', 'times']" v-if="!question.IsPositiveAnswer"></font-awesome-icon>
                    <font-awesome-icon :icon="['far', 'check']" v-if="question.IsPositiveAnswer"></font-awesome-icon>
                    {{ question.SurveyAnswerText}}
                  </td>
                  <td v-if="hasUploadQuestion && userHasMediaExplorerPermission">
                    <!-- disable if question.UploadQuestion.SurveyInstanceId & SurveyQuestionId are null or undefined -->
                    <button class="btn btn-light" v-if="question.UploadQuestion && question.UploadQuestion.hasUploadFile" @click="toggleUpload(question.UploadQuestion)">
                      <font-awesome-icon 
                        :icon="['far', 'eye-slash']" 
                        v-if="uploadToggled && shownUploadQuestionId == question.UploadQuestion.SurveyQuestionId && shownUploadSurveyInstanceId == question.UploadQuestion.SurveyInstanceId"
                      ></font-awesome-icon>
                      <font-awesome-icon :icon="['far', 'eye']" v-else ></font-awesome-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="m-2">
            <div>
              <h5>Group Availability (%):</h5> 
              <BarGraph class="px-2" :thresholds="ColorRange" :val="PCTGroupAvailability"/>
            </div>
            <div>
              <h5>Accepted Chats (%):</h5>
              <BarGraph class="px-2" :thresholds="ColorRange" :val="100-PCTMissedChats"/>
            </div>
          </div>
        </template>
        
      </div>
      <!-- <div class="uploadImageContainer" v-if="uploadToggled">
        <b-img class="uploadImage" v-if="uploadPicture" :src="uploadPicture" alt="" v-b-modal.modal-center></b-img> -->
        <b-modal id="modal-center" size="xl" centered hide-footer v-model="uploadToggled">
          <b-img class="uploadImageInModal" v-if="uploadPicture" :src="uploadPicture" alt=""></b-img>
        </b-modal>
      <!-- </div> -->
    </b-card-text>
  </b-card>
</template>

<script>
import EventBus from "@/services/EventBus";
import DashboardService from "@/services/DashboardService";
import { i18n, changeLocalization } from "@/i18n";
import AppConfig from '@/mixins/AppConfig';
import ReportsService from '@/services/ReportsService';
import SurveysService from '@/services/SurveysService';
import DownloadFileMixin from '@/mixins/DownloadFileMixin';
import AuthenticationService from '@/services/AuthenticationService';
import BarGraph from './DashboardCards/BarGraph';

export default {
  name: "MarginKpiPopup",

  components: {
    DashboardService,
    ReportsService,
    SurveysService,
    AuthenticationService,
    BarGraph
  },
  mixins: [ AppConfig, DownloadFileMixin ],
  props: {
    ColorRange: Array,
    ClientLocationId: Number,
    Kpi: Object,
    WaveName: String,
    Brand: String
  },
  data() {
    return {
      surveyWave: null,
      kpiQuestions: null,
      kpiQuestions_SophusMonthly: null,
      isExporting: false,
      uploadPicture: null,
      shownUploadQuestionId: null,
      shownUploadSurveyInstanceId: null,
      isLoading: false,
      uploadToggled: false,
      hasUploadQuestion: false,
      PCTGroupAvailability: null,
      PCTMissedChats: null
    };
  },
  computed: {
    userHasMediaExplorerPermission() {
      return AuthenticationService.localUserProfile.Permissions.includes("MediaExplorer");
    },
    isEmpty_kpiQuestions() {
      return _.isEmpty(this.kpiQuestions);
    },
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh(){
      this.isLoading = true;
      this.uploadToggled = false;
      this.hasUploadQuestion = false;
      this.surveyWave = this.Kpi.SurveyWave.find(x => x.Name == this.WaveName)
      var body = {
        "ClientLocationId": this.ClientLocationId,
        "SurveyKpiIds": this.Kpi.SurveyKpiIds, 
        "SurveyWaveIds": this.surveyWave.SurveyWaveIds,
        "LocalizationId": i18n.locale,
        "Year": 2021
      }
      DashboardService.GetSurveyKpiQuestionAndAnswerTexts(body)
      .then(async (res) => {
        const surveys = {};
        for (var index in res.data) {
          if (surveys[res.data[index].SurveyInstanceId] == undefined){
            surveys[res.data[index].SurveyInstanceId] = [];
          }
          surveys[res.data[index].SurveyInstanceId].push(res.data[index]);
          if(res.data[index].UploadQuestion) {
            this.hasUploadQuestion = true;
          }
        }

        this.kpiQuestions = surveys;
        
        if(this.Kpi.SophusMonthly) {
          await this.getSophusRawData();
          await this.getSophusMonthly();
        }

        if(!res.data) { throw Error("Could not query questions and answers for", body)}
      })
      .catch(error => console.warn("Error while loading marginKpiPopup: " + error))
      .finally(() => {
        this.isLoading = false;
      });
    },
    downloadCheckReport(surveyInstanceId) {
      this.isExporting = true;
      ReportsService.getCheckReport(
        surveyInstanceId,
        { localizationId: i18n.locale })
        .then(response => {
          this.downloadFile(response);
          this.isExporting = false;
        })
        .catch(_ => { 
          this.isExporting = false; 
          this.$bvToast.toast(
            this.$t("Webportal.CX.Margin.CheckReportErrorMessage"),
            {
              title: this.$t("Webportal.CX.Margin.CheckReportErrorTitle"),
              autoHideDelay: 5000,
              variant: "danger",
              noCloseButton: true,
            }
          );
        } 
      );
    },
    toggleUpload(uploadQuestion) {
      if(this.uploadToggled && this.shownUploadQuestionId == uploadQuestion.SurveyQuestionId && this.shownUploadSurveyInstanceId == uploadQuestion.SurveyInstanceId) {
        this.uploadPicture = null;
        this.shownUploadQuestionId = null;
        this.shownUploadSurveyInstanceId = null;
        this.uploadToggled = false;
        return;
      }
      this.uploadToggled = true;
      this.uploadPicture = null;
      this.shownUploadQuestionId = null;
      this.shownUploadSurveyInstanceId = null;
      SurveysService.getSurveyUploadFile([uploadQuestion.SurveyInstanceId] ,[uploadQuestion.SurveyQuestionId])
      .then((res) => {
        if(res.status == 200) {
          this.shownUploadQuestionId = uploadQuestion.SurveyQuestionId;
          this.shownUploadSurveyInstanceId = uploadQuestion.SurveyInstanceId;
          this.uploadPicture = window.URL.createObjectURL(new Blob([res.data]));
        } else if(res.status == 204) {
          // no content
          this.shownUploadQuestionId = uploadQuestion.SurveyQuestionId;
          this.shownUploadSurveyInstanceId = uploadQuestion.SurveyInstanceId;
          this.uploadPicture = window.URL.createObjectURL(new Blob([{}]));
          // v-b-modal.modal-center
          this.$bvModal.show('modal-center')
        }
      })
    },
    async getSophusMonthly() {
      // return if no SophusMonthly-Wave was found for selected wave
      if(!this.Kpi.SophusMonthly.SurveyWave.find(sw => sw.Name === this.WaveName)) return;

      var body = {
        "ClientLocationId": this.ClientLocationId,
        "SurveyKpiIds": this.Kpi.SophusMonthly.SurveyKpiIds, 
        "SurveyWaveIds": this.Kpi.SophusMonthly.SurveyWave.find(sw => sw.Name === this.WaveName).SurveyWaveIds,
        "ScenarioName": this.Kpi.SophusMonthly.SurveyWave.find(sw => sw.Name === this.WaveName).Scenario,
        "LocalizationId": i18n.locale,
        "Year": 2023
      }
      return DashboardService.GetSurveyKpiQuestionAndAnswerTexts(body)
      .then((res) => {
        const surveys = {};
        for (var index in res.data) {
          if (surveys[res.data[index].SurveyInstanceId] == undefined){
            surveys[res.data[index].SurveyInstanceId] = [];
          }
          surveys[res.data[index].SurveyInstanceId].push(res.data[index]);
        }

        this.kpiQuestions_SophusMonthly = surveys;
        if(!res.data) { throw Error("Could not query questions and answers for", body)};
      })
      .catch(error => console.warn("Error while loading marginKpiPopup: " + error))
    },
    async getSophusRawData() {

      return DashboardService.GetSophusRawData(this.ClientLocationId, this.WaveName, this.Brand)
      .then(res => {
        this.PCTGroupAvailability = res.data.PCTGroupAvailability;
        this.PCTMissedChats = res.data.PCTMissedChats;
      })
      .catch(error => console.warn("Error while loading sophus rawdata: " + error))
    }
  },
  watch: {
    Kpi: function(newVal, oldVal) { if(newVal !== oldVal) {this.refresh()}},
    surveyWave: function(newVal, oldVal) { if(newVal !== oldVal) {this.refresh()}},
    WaveName: function(newVal, oldVal) { if(newVal !== oldVal) {this.refresh()}}
  }
};
</script>

<style scoped>
.table-body {
  color: var(--color-primary-inverse);
}

.popup {
  box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
  border: none;
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  overflow: auto;
  width: 650px;
  min-height: 25vh !important;
  max-height: 75vh;
}
.content {
  display:flex;
  flex-direction: row;
  margin: 1rem;
  justify-content: space-between;
  max-height: 100%;
}

.uploadImage {
  margin: auto;
  cursor: zoom-in;
  width: 90%;
}
.uploadImageContainer {
  position: sticky;
  width: 600px;
  top: 0%;
  left: 0%;
  height: auto;
  display: flex;
  justify-content: center;
}
.uploadImageInModal {
  width: 100%;
  margin: auto;
}
</style>